const permissions = {
  viewOrdersIntegrations: 'OI001',
  addOrdersIntegrations: 'OI002',
  editOrdersIntegrations: 'OI003',
  deleteOrdersIntegrations: 'OI004'
};

export default permissions;
